<label>
  <span>{{ label }}:</span>
  <ng-content></ng-content>
</label>
